/* Doubled to outrank the shared select's own full width. */
.select.select {
  /* Room for a name; a narrow topbar first leaves out the shallower segments (ScopeTrail), and
     only then shrinks these, never below an avatar and a few characters. */
  width: 13rem;
  min-width: 9rem;
  flex: 0 1 auto;
}

/* The deepest segment alone in a phone's topbar may shrink further. */
@container scope-trail (width < 19.5rem) {
  .select.select {
    min-width: 6rem;
  }
}

/* An option's or the selected value's avatar, with room for its level badge. */
.media {
  display: inline-flex;
  flex: 0 0 auto;
  /* The badge reaches 6px past the avatar. */
  margin-inline-end: 0.5rem;
}

/* An option's or the selected value's icon (a policy's, a category's). */
.icon {
  display: inline-flex;
  flex: 0 0 auto;
  color: var(--color-muted-foreground);
}

.label {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.375rem;
}

.name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action {
  width: 100%;
  justify-content: flex-start;
}
